interface AppConfig {
  API_URL: string;
  Contracts_URL: string;
  ContractsAPI_URL: string;
  ContractsArchive_URL: string;
  ContactAPI_URL: string;
  ESPEC_URL: string;
}

// Default fallback config (used only if fetch fails)
const defaultConfig: AppConfig = {
  API_URL: "https://webapi.icegems.com/api",
  Contracts_URL: "https://contracts.icegems.com",
  ContractsAPI_URL: "https://contractswebapi.icegems.com/api",
  ContractsArchive_URL: "https://icegems.com/ContractsArchive",
  ContactAPI_URL: "https://contactwebapi.icegems.com/api",
  ESPEC_URL: "https://espec.com",
};

let appConfig: AppConfig | null = null;

/**
 * Load runtime config BEFORE the app starts
 */
export async function loadConfig(): Promise<void> {
  try {
    const response = await fetch("/config.json", {
      cache: "no-store", // prevents browser caching
      headers: {
        "Cache-Control": "no-cache",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    // Merge with defaults to prevent undefined values
    appConfig = { ...defaultConfig, ...data };

    console.log("Configuration loaded:", appConfig);
  } catch (error) {
    console.error("Failed to load configuration. Using defaults.", error);
    appConfig = defaultConfig;
  }
}

/**
 * Ensure config is loaded before access
 */
function ensureConfig(): AppConfig {
  if (!appConfig) {
    throw new Error(
      "Config not loaded yet. Make sure loadConfig() is called before app startup."
    );
  }
  return appConfig;
}

// Individual getters
export const getApiUrl = () => ensureConfig().API_URL;
export const getContractsUrl = () => ensureConfig().Contracts_URL;
export const getContractsAPIUrl = () => ensureConfig().ContractsAPI_URL;
export const getContractsArchiveUrl = () => ensureConfig().ContractsArchive_URL;
export const getContactAPIUrl = () => ensureConfig().ContactAPI_URL;
export const getESPECUrl = () => ensureConfig().ESPEC_URL;

// Full config getter
export const getConfig = (): AppConfig => ensureConfig();